import { render, staticRenderFns } from "./ApprovalListTable.vue?vue&type=template&id=ae6ad124"
import script from "./ApprovalListTable.vue?vue&type=script&lang=ts"
export * from "./ApprovalListTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports